var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEyeOff = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M9.25 12.55q-.619.117-1.25.117A6.67 6.67 0 0 1 1.638 8 6.7 6.7 0 0 1 2.68 5.98m3.906.606a2 2 0 1 1 2.828 2.829M6.586 6.586l2.828 2.829M6.586 6.586l2.828 2.827m0 .002 2.194 2.193M6.587 6.587 4.394 4.393m0 0L2 2m2.394 2.393A6.67 6.67 0 0 1 14.363 8a6.68 6.68 0 0 1-2.755 3.607M4.393 4.393l7.214 7.214m0 0L14 14"
})));
export default SvgEyeOff;